module.exports = __webpack_public_path__ + "static/media/climate-justice-waves.edcef754.svg";